import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { TerminalHoldStatusModal } from 'components/modules/shipments/TerminalHoldStatusModal';

export const TerminalHoldStatusEditor = forwardRef(
  ({ stopEditing, data, node }, ref) => {
    /**
     * data has shipment details, extracting only required one
     */
    const { shipment_oid, terminal_hold_status } = data;

    /**
     * Required state for holding existing data
     */
    const [open, setOpen] = useState(true);
    const [value, setValue] = useState(terminal_hold_status || []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },
      };
    });
    /**
     * Handle after success
     */
    function handleSuccess(payload) {
      const update = payload?.terminal_hold_status || [];
      setValue(update);
      node.updateData({
        ...data,
        ...update,
      });
      stopEditing();
      setOpen(false);
    }

    /**
     * Once modal closed
     */
    function handleHide() {
      stopEditing();
      setOpen(false);
    }

    return (
      <TerminalHoldStatusModal
        open={open}
        onHide={handleHide}
        onSuccess={handleSuccess}
        shipmentId={shipment_oid}
      />
    );
  },
);
